class PeoplePage {
    constructor() {
        $("#people-categories").on('change', function() {
            window.location = this.value;
        });

        $("#view-grid-btn").click(function() {
            $(".people-grid").addClass("grid-view").removeClass("list-view");
        });

        $("#view-list-btn").click(function() {
            $(".people-grid").removeClass("grid-view").addClass("list-view");
        });
    }
}

export default PeoplePage;